export default class Informativo {
    
    constructor(model = null){
        
        this.id = 0;
        this.empresaId = 0;
        this.emails = "";
        this.periodicidade = 0;
        this.contaCorrente = false;
        this.compromissos = false;
        this.recebiveis = false;
        this.subAtividadeNegativa = false;
        this.crm = false;
        this.beneficiarios = false;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.emails = model.emails;
        this.periodicidade = model.periodicidade;
        this.contaCorrente = model.contaCorrente;
        this.compromissos = model.compromissos;
        this.recebiveis = model.recebiveis;
        this.subAtividadeNegativa = model.subAtividadeNegativa;
        this.crm = model.crm;
        this.beneficiarios = model.beneficiarios;
    }
}